
import React from 'react';
import { Input } from '../../../../../components/ui/input';
import { BaseFieldPreviewProps } from './previewUtils';

const TextFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription }) => {
  return (
    <div>
      {renderDescription()}
      <Input placeholder={field.placeholder || 'Kurze Antwort'} disabled className="bg-white" />
    </div>
  );
};

export default TextFieldPreview;
